import { useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { apiClient } from "~/api/ApiClient";
import { useAuth } from "~/contexts/AuthProvider";
import { PENDING_INVITE_UUID_STORAGE_KEY } from "~/helpers/consts";
import { tryCatchParsed } from "~/helpers/tryCatch";
import { teamsQueries } from "~/hooks/useTeams";
import { routes } from "~/router";

export function PendingInvitationHandler() {
  const { user, refetchUser } = useAuth();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const hasTriggered = useRef(false);

  useEffect(() => {
    // here user must exist
    if (!user) return;
    if (hasTriggered.current) return;

    const uuid = localStorage.getItem(PENDING_INVITE_UUID_STORAGE_KEY);
    if (!uuid) return;

    hasTriggered.current = true;

    const accept = async () => {
      const { error } = await tryCatchParsed(
        apiClient.invitations.acceptCreate(uuid),
      );

      localStorage.removeItem(PENDING_INVITE_UUID_STORAGE_KEY);

      if (error) {
        enqueueSnackbar("Failed to accept invitation.", {
          variant: "error",
          persist: true,
        });

        return;
      }

      await refetchUser();
      await queryClient.invalidateQueries({ queryKey: teamsQueries.all });
      navigate(routes.home(), { replace: true });
      enqueueSnackbar("Invitation was successfully accepted.", {
        variant: "success",
      });
    };

    accept();
  }, [user, queryClient]);

  return null;
}
